module.exports = __webpack_public_path__ + "img/autospin_btn.2ce757fd.png";